import _ from 'lodash';

class Affix {
  constructor($el, affixTop) {
    this.$el = $el;
    this.elPosition = this.$el.offset();
    this.$parent = this.$el.parent();
    this.affixTop = affixTop;
    const parentPosition = this.$parent.offset().top;

    this.stop = parentPosition + (affixTop ? this.$parent.innerHeight() : this.$parent.outerHeight());
    this.stopTop = parentPosition;

    this.scrolling = this.scrolling.bind(this);

    // eslint-disable-next-line no-magic-numbers
    window.addEventListener('scroll', _.throttle(this.scrolling, 10));
  }

  scrolling() {
    const windowPosition = $(window).scrollTop();
    const windowHeight = $(window).height();

    if (this.affixTop) {
      const fixedPositionTop = 100;

      if (windowPosition + this.$el.outerHeight() + fixedPositionTop >= this.stop) {
        this.$el.removeClass('affix').addClass('affix-bottom');
      } else if (windowPosition > this.elPosition.top - fixedPositionTop) {
        this.$el.addClass('affix').removeClass('affix-bottom');
      } else {
        this.$el.removeClass('affix affix-bottom');
      }
    } else {
      const fixedPositionBottom = 20;

      if (windowPosition + windowHeight - this.$el.outerHeight() + fixedPositionBottom >= this.stop) {
        this.$el.removeClass('affix').addClass('affix-bottom');
      } else if (windowPosition + windowHeight > this.elPosition.top + this.$el.outerHeight()) {
        this.$el.addClass('affix').removeClass('affix-bottom affix-top');
      } else {
        this.$el.removeClass('affix affix-bottom').addClass('affix-top');
      }
    }
  }
}

export default Affix;
